
import { Component, Vue } from "vue-property-decorator";
import {
  dispatchGetPhysicalNodesActive
} from "@/store/mlm/actions";
import {
  readPhysicalNodesActive
} from "@/store/mlm/getters";
import { IAcquiredNode } from "@/interfaces/mlm";
@Component({
  components: {
  },
})
export default class PhysicalNodesActive extends Vue {
  
  // methods
  
public async mounted() {
  if(this.physicalNodesActive.length == 0){
        await dispatchGetPhysicalNodesActive(this.$store)
    }
}

 get physicalNodesActive() {
    return readPhysicalNodesActive(this.$store)
  }

  get sortedAcquiredNodes() {
    return [...this.physicalNodesActive].sort((a, b) => {
      const orderIdA = a.order_id || 0;
      const orderIdB = b.order_id || 0;
      return orderIdA - orderIdB;
    });
  }
  
}
